import * as React from 'react';
import { connect } from 'react-redux';
import * as minuteDiff from 'minute-diff';
import { Notification, Pagination, Loader, Box } from '../';
import NoteItem from './NoteItem';
import NoteForm from './NoteForm';
import { getNotes } from '../../redux/actions/notes';
import { getUsers } from '../../redux/actions/users';
import PAGINATE from '../../data/paginate';

interface Props {
  id?: number;
  resource?: string;
  dispatch: Function;
  hideForm: boolean;
  hideTitle?: boolean;
  title?: string;
  assignee?: number;
  author?: number;
  unresolved?: boolean;
  resolveable?: boolean;
  users: any;
}

interface State {
  isLoaded: boolean;
  notes: Array<any>;
  users: Array<any>;
  page: number;
  error: string | boolean;
}

class NoteList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      notes: [],
      page: 0,
      users: [],
      error: false,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  async componentDidMount() {
    if (
      !this.props.users.lastUpdated ||
      minuteDiff(this.props.users.lastUpdated) >= 1
    ) {
      await this.props.dispatch(getUsers());
    }
    this.handleUpdate();
  }

  componentWillReceiveProps() {
    if (this.state.isLoaded) {
      this.setState({ isLoaded: false }, () => {
        this.handleUpdate();
      });
    }
  }

  async handleUpdate() {
    const params = {
      id: this.props.id,
      type: this.props.resource,
      page: this.state.page,
      assignee: this.props.assignee,
      author: this.props.author,
      unresolved: this.props.unresolved,
      resolveable: this.props.resolveable,
    };

    if (this.props.unresolved) {
      params.page = 0;
    }
    const response = await this.props.dispatch(getNotes(params));
    if (response.error) {
      this.setState({ isLoaded: true, error: response.error });
      return;
    }
    this.setState({ isLoaded: true, error: false, notes: response.data });
  }

  render() {
    const notes = this.state.notes;
    return (
      <div>
        {this.props.hideForm ||
          (this.props.id !== undefined && (
            <Box>
              <NoteForm
                id={this.props.id}
                resource={this.props.resource}
                handleUpdate={this.handleUpdate}
                hasDropdown
              />
            </Box>
          ))}
        {!this.state.isLoaded ? (
          <Loader fullwidth />
        ) : notes.length === 0 ? (
          this.state.error !== false ? (
            <Notification type="danger">{this.state.error}</Notification>
          ) : (
            <Notification type="default">No notes found</Notification>
          )
        ) : (
          <Box>
            {notes.map((note, index) => {
              if (index >= PAGINATE.notes.MAX) {
                return null;
              }
              return (
                <NoteItem
                  key={note.id}
                  note={note}
                  showParentInfo={this.props.id === undefined}
                />
              );
            })}
          </Box>
        )}
        {notes.length > 0 && this.state.isLoaded && (
          <Pagination
            page={this.props.unresolved ? 0 : this.state.page}
            lastPage={notes.length <= PAGINATE.notes.MAX}
            handleUpdate={(page) => {
              this.setState({ page, isLoaded: false }, () => {
                this.handleUpdate();
              });
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => ({
  users,
});

export default connect(mapStateToProps)(NoteList);
